/**
 * Helpers shared by every per-entity SEO builder (products, bundles).
 *
 * Kept in one place so brand keywords and normalization rules cannot drift
 * between the builders that emit page metadata.
 */

export const BRAND_KEYWORDS = [
  'SEECH',
  'Seech Spectrum',
  'Seech apps',
  'Spectrum marketplace',
];

export const normalizeText = (value?: string | null): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length ? trimmed : undefined;
};

export const normalizeKeywords = (
  keywords?: string | string[] | null
): string[] => {
  if (!keywords) {
    return [];
  }
  const source = Array.isArray(keywords) ? keywords : keywords.split(',');
  return source.map((keyword) => keyword.trim()).filter(Boolean);
};

/** Merges keyword sets in order, dropping blanks and case-insensitive repeats. */
export const mergeKeywordSets = (...sets: string[][]): string[] => {
  const seen = new Set<string>();
  const merged: string[] = [];

  sets.forEach((set) => {
    set.forEach((keyword) => {
      const trimmed = keyword.trim();
      if (!trimmed) {
        return;
      }
      const key = trimmed.toLowerCase();
      if (seen.has(key)) {
        return;
      }
      seen.add(key);
      merged.push(trimmed);
    });
  });

  return merged;
};
